/**
 * Error page translations
 * Includes: Error page messages and actions
 */
export default {
  notFound: {
    title: 'Page Not Found',
    description: 'Sorry, the page you are looking for does not exist or has been moved.',
    goHome: 'Back to Home',
  },
  devtool: {
    title: 'Developer Tools Detected',
    description: 'To protect user privacy and data security, we have detected that you have opened browser developer tools.',
    warning1: 'Using developer tools may expose sensitive user information',
    warning2: 'Malicious use of developer tools may lead to account theft or data leakage',
    warning3: 'Please close the developer tools immediately to ensure your account security',
    closeAndReturn: 'I\'ve closed it, return to home',
    pleaseCloseDevTools: 'Please close the developer tools first',
  },
}
